import { useEffect, useState } from "react";

import {
    getAdminUsers,
    deleteAdminUser,
} from "../services/adminUserApi";

import AdminUserHeader from "../components/adminUsers/AdminUserHeader";
import AdminUserStats from "../components/adminUsers/AdminUserStats";
import AdminUserFilters from "../components/adminUsers/AdminUserFilters";
import AdminUserTable from "../components/adminUsers/AdminUserTable";
import AdminUserForm from "../components/adminUsers/AdminUserForm";

import "../css/AdminUsers.css";
function AdminUsers() {

    const [admins, setAdmins] = useState([]);

    const [loading, setLoading] = useState(true);

    const [showForm, setShowForm] = useState(false);

    const [selectedAdmin, setSelectedAdmin] = useState(null);

    const [filters, setFilters] = useState({

        search: "",

        status: "",

    });

    const loadAdmins = async () => {

        try {

            setLoading(true);

            const res = await getAdminUsers();

            setAdmins(res.data);

        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);

        }

    };

    useEffect(() => {

        loadAdmins();

    }, []);

    const handleFilterChange = (key, value) => {

        setFilters((prev) => ({
            ...prev,
            [key]: value,
        }));

    };

    const filteredAdmins = admins.filter((admin) => {

        const matchesSearch =
            admin.fullName
                .toLowerCase()
                .includes(filters.search.toLowerCase()) ||

            admin.email
                .toLowerCase()
                .includes(filters.search.toLowerCase());

        const matchesStatus =
            !filters.status ||

            admin.status === filters.status;

        return matchesSearch && matchesStatus;

    });

    const handleDelete = async (id) => {

        await deleteAdminUser(id);

        loadAdmins();

    };

    return (

        <div className="admin-users-page">

            <AdminUserHeader

                reload={loadAdmins}

                onAddAdmin={() => {

                    setSelectedAdmin(null);

                    setShowForm(true);

                }}

            />

            <AdminUserStats admins={admins} />

            <AdminUserFilters

                filters={filters}

                onChange={handleFilterChange}

            />

            <AdminUserTable

                admins={filteredAdmins}

                loading={loading}

                reload={loadAdmins}

                onDelete={handleDelete}

                onEdit={(admin)=>{

                    setSelectedAdmin(admin);

                    setShowForm(true);

                }}

            />

            <AdminUserForm

                open={showForm}

                onClose={() => setShowForm(false)}

                initialData={selectedAdmin}

                reload={loadAdmins}

            />

        </div>

    );

}

export default AdminUsers;